import { ajustaPropiedadesIndefinidas } from '@/constantes/helpers';
import { ROL_BASE_OBJ, ROL_MASTER_OBJ, ADMIN_MASTER_ID } from '@/constantes/panel_roles';
import firebase from '@/firebase'
import { FS_COLLECTIONS } from '@/firebase'
const db = firebase.firestore()

var cargadorCatalogosPanelRoles = null;
var cargadorRol = null;

const store = {
  state: {
    panelRol:{},
    panelRoles:{},
    panelRolHeader:{},
  },
  getters: {
    panelRol: state => {
      return state.panelRol;
    },
    panelRolHeader: state => {
      return state.panelRolHeader;
    },
    panelRoles: state => {
      return state.panelRoles;
    },
  },
  mutations: {
    ASIGNA_PANELROL(state, data) {
      state.panelRol= data;
    },
    ASIGNA_PANELROL_HEADER(state, data) {
      state.panelRolHeader= data;
    },
    ASIGNA_PANELROLES(state, data) {
      state.panelRoles= data;
    },
  },
  actions: {

    agregarPanelRol({ dispatch, getters }, panelRol) {
      return new Promise((resolve, reject) => {
        db.collection("Panel_Roles")
        .add(panelRol)
          resolve()
      })
    },

    actualizarPanelRol({ dispatch, getters }, panelRol) {
       return new Promise((resolve, reject) => {
        db.collection("Panel_Roles")
           .doc(panelRol.id)
           .update(panelRol)

           resolve()
       })
     },


    eliminarPanelRol({getters}, idRol) {
      return db.collection("Panel_Roles")
        .doc(idRol)
        .delete()
    },



    /**CARGAR ROL SELECCIONADO */
    cargarPanelRol({ commit,getters }, idRol) {
      console.log('Store panelRoles carga: ' + idRol)
      return new Promise((resolve, reject) => {
        let docPath = db.collection("Panel_Roles").doc(idRol);
        docPath.onSnapshot(doc => {
          commit('ASIGNA_PANELROL', doc.data())
          resolve(doc.data())
        })
      })
    },

    cargarPanelRolHeader({ commit,getters }, idRol) {
      return new Promise((resolve, reject) => {
        // El admin master siempre tiene acceso total en el panel, sin importar
        // el rol que tenga (o no tenga) asignado en Panel_Roles.
        if (getters.usuario && getters.usuario.id === ADMIN_MASTER_ID) {
          const data = JSON.parse(JSON.stringify(ROL_MASTER_OBJ))
          commit('ASIGNA_PANELROL_HEADER', data)
          resolve(data)
          return
        }
        if (cargadorRol === null) {
          let docPath = db.collection("Panel_Roles").doc(idRol);
          cargadorRol = docPath.onSnapshot(doc => {
            const data = ajustaPropiedadesIndefinidas(JSON.parse(JSON.stringify(ROL_BASE_OBJ)), doc.data())
            commit('ASIGNA_PANELROL_HEADER', data)
            resolve(data)
          })
        } else {
          resolve()
        }
      })
    },


    /** Cargar lista de panelRoles para la tabla */
    cargaIndicePanelRoles({ commit, getters }) {
      return new Promise((resolve, reject) => {
        if (cargadorCatalogosPanelRoles === null) {
          let docPath = db
            .collection(FS_COLLECTIONS.PIXAN)
            .doc('Panel_Roles')
          cargadorCatalogosPanelRoles = docPath.onSnapshot(doc => {
            resolve()
            commit('ASIGNA_PANELROLES', doc.data())
          })
        } else {
          resolve()
        }
      })
    },
   
    

  }
}

export default store



// WEBPACK FOOTER //
// ./src/store/panel_roles/panel_roles.js